"use strict";
exports.__esModule = true;
exports.CREDIT_BUILDER_CREDIT_SCORE = void 0;
exports.CREDIT_BUILDER_CREDIT_SCORE = {
    SCORE_LABEL: {
        POOR: 'Poor',
        FAIR: 'Fair',
        GOOD: 'Good',
        VERY_GOOD: 'Very good',
        EXCELLENT: 'Excellent',
        UNAVAILABLE: 'Credit score\nunavailable'
    },
    SCORE_CHANGE: 'from last month',
    NEXT_UPDATE: 'Next update in',
    SINCE_JOINING: 'since joining Flex',
    RENT_HISTORY: 'rent history reported'
};
